import { createStore } from 'vuex'

export const store = createStore({
    state: {
        desktop_screen: true,
        main_data: null,
        calendar_state_data: {
            mode: 'drills',
            placing_vid: {
                vimeo_id: null,
                title: null,
                dropped_on: null,
                pending_deletion: null
            },
            placed_vimeo_ids_list: []
        }
    },
    actions: {
        placingVideo: ({commit, dispatch}, vid_data) => {
            commit('setCalendarMode', 'schedule');
            commit('setCalendarVideoBeingPlaced', vid_data);
        },
        // resetCalendarState
    },
    mutations: {
        setData: (state, data) => {
            state.main_data = data;
        },
        setCalendarData: (state, data) => {
            state.main_data.calendar_data = data;
        },
        setScreenMode: state => {
            state.desktop_screen = window.innerWidth >= 1024;
        },
        setCalendarMode: (state, mode) => {
            state.calendar_state_data.mode = mode;
            state.calendar_state_data.placing_vid.vimeo_id = null;
            state.calendar_state_data.placing_vid.title = null;
        },
        setCalendarVideoBeingPlaced: (state, data) => {
            state.calendar_state_data.placing_vid.vimeo_id = data.vimeo_id;
            state.calendar_state_data.placing_vid.title = data.video_data.title;
            if(data.pending_deletion)
            {
                state.calendar_state_data.placing_vid.pending_deletion = data.pending_deletion;
            }else{
                state.calendar_state_data.placing_vid.pending_deletion = null;
            }
        },
        dropVideoOnCalendarDay: (state, date) => {
            state.calendar_state_data.placing_vid.dropped_on = date;
        },
        resetVideoPlacement: (state) => {
            state.calendar_state_data.placing_vid.vimeo_id = null;
            state.calendar_state_data.placing_vid.title = null;
            state.calendar_state_data.placing_vid.dropped_on = null;
            state.calendar_state_data.placing_vid.pending_deletion = null;
        },
        syncPlacedVideosList: (state, list_of_ids) => {
            state.calendar_state_data.placed_vimeo_ids_list = list_of_ids;
        },
        mergeUpdatedStarredVideos: (state, new_library_favorites) => {

            if(state.main_data)
            {
                state.main_data.user_data.library_favorites = new_library_favorites;
            }
        }
    },
    getters: {
        isDesktopScreen: state => state.desktop_screen,
        getCalendarMode: state => state.calendar_state_data.mode,
        getCalendarVideoBeingPlaced: (state) => {
            return state.calendar_state_data.placing_vid;
        },
        isPlacementModeActive: (state) => {
            return !!state.calendar_state_data.placing_vid.vimeo_id;
        },
        placedVimeoIdsList: (state) => {
            return state.calendar_state_data.placed_vimeo_ids_list;
        },
        getMainData: state => state.main_data,
        getPrivateLibrary: (state) => {

            if(!state.main_data)
            {
                return null;
            }
            return state.main_data?.user_data.library_favorites.sort(function(a,b){
                return a.video_data['uploaded_at'] < b.video_data['uploaded_at'];
            });
        }
    }
});
